import { connect } from 'react-redux';
import ContentTopBar from '../../../components/layout/ContentTopBar';
import { userInfo } from 'core/selectors';
import { logOut } from 'core/slices/session';

export default connect(
  state => ({
    sessionInfo: userInfo(state),
  }),
  {
    logOut,
  },
)(ContentTopBar);
